import './Projects.css';
import React, { useRef } from 'react';
import AnimationforWork from '../animations/AnimationforWork';
import useScrollReveal from '../../hooks/useScrollReveal';

const Projects = ({ isDarkMode }) => {
  const containerRef = useRef(null);

  useScrollReveal(containerRef);

  const projectData = [
    {
      link: 'https://github.com/VedantSupnekar/Treble-Playlist-Convertor',
      logo: '/trebleplaylist.png',
      title: 'Treble Playlist Converter',
      description: 'Led the development of a cross-platform music playlist conversion app utilizing the MERN Stack. Deployed the app on Azure, ensuring scalability and reliability with optimized resource allocation.',
      techStack: ['MongoDB', 'Express', 'React', 'Node.js', 'Azure'],
    },
    {
      link: 'https://github.com/VedantSupnekar/ValTrack-Discord-Bot',
      logo: '/valbot.png',
      title: 'Valorant Discord Bot',
      description: 'Developed during HackWesTX 2023, this Discord bot enhances player experience with game tracking and tips. Features include agent selection, strategy roulette, and competitive tips, built with Python and Flask, and deployed on Google Cloud Platform.',
      techStack: ['Python', 'Flask', 'GCP', 'Discord API'],
    },
    {
      link: 'https://github.com/VedantSupnekar/RD-Syntax-Parser',
      logo: '/parser.png',
      title: 'RD Syntax Parser',
      description: 'Designed a Recursive Descent Syntax Parser in Python to analyze and validate the grammar of programming language tokens. Efficiently parses input strings and provides syntax error reporting.',
      techStack: ['Python', 'Compilers'],
    },
    {
      link: 'https://github.com/VedantSupnekar/Song-Genre-Classification-Project',
      logo: '/genre.png',
      title: 'Song Genre Classification',
      description: 'Implemented a machine learning model to classify songs into genres based on audio features. Used scikit-learn and Python for data preprocessing, model training, and evaluation.',
      techStack: ['Python', 'scikit-learn', 'ML'],
    },
    {
      link: 'https://github.com/VedantSupnekar/ConwaysGameOfLife-Multithreading',
      logo: '/conway.png',
      title: "Conway's Game of Life – Multithreaded",
      description: 'Created a multithreaded implementation of Conway\'s Game of Life using Python and pthreads to handle concurrent cell updates, improving execution efficiency on larger grids.',
      techStack: ['Python', 'Multithreading', 'pthreads'],
    },
    {
      link: 'https://github.com/VedantSupnekar/HealthBridge',
      logo: '/healthbridge.png',
      title: 'Health Bridge',
      description: 'Designed a dynamic COVID-19 Symptom Survey app with a 20-point diagnosis system. Integrated Google Maps API to redirect users to nearby healthcare centers and suggest personalized precautions based on geolocation data.',
      techStack: ['Python', 'Flask', 'Google Maps API', 'GeoLocation'],
    }
  ];

  return (
    <>
      <div className="spacery4">
        <div className='headding'>
          <AnimationforWork isDarkMode={isDarkMode} />
          <div className="textDiv">
            <h1> Projects </h1>
          </div>
        </div>
      </div>

      <div ref={containerRef} className="container project-container bento-grid">
        {projectData.map((project, index) => (
          <a key={index} href={project.link} target="_blank" rel="noopener noreferrer" className="bento-link">
            <div className={`card bento-card scroll-reveal`} data-delay={index + 1}>
              {/* Terminal overlay */}
              <div className="terminal-overlay">
                <div className="terminal-header">
                  <span className="terminal-dot red" />
                  <span className="terminal-dot yellow" />
                  <span className="terminal-dot green" />
                  <span className="terminal-title">~/stack</span>
                </div>
                <div className="terminal-body">
                  {project.techStack.map((tech, i) => (
                    <div key={i} className="terminal-line">
                      <span className="terminal-prompt">$</span> {tech}
                    </div>
                  ))}
                </div>
              </div>

              <svg className="with-icon_icon__MHUeb link-icon" data-testid="geist-icon" fill="none" height="24" shapeRendering="geometricPrecision" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24">
                <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
                <path d="M15 3h6v6" />
                <path d="M10 14L21 3" />
              </svg>

              <div className="logo-container">
                <img src={isDarkMode ? project.logo.replace('.png', '.png') : project.logo} alt={project.title} className="company-logo" />
              </div>

              <div className="info-container">
                <div className="position">
                  <strong>{project.title}</strong> &nbsp;
                  <svg className="with-icon_icon__MHUeb link-icon2" data-testid="geist-icon" fill="none" height="24" shapeRendering="geometricPrecision" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24">
                    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
                    <path d="M15 3h6v6" />
                    <path d="M10 14L21 3" />
                  </svg>
                </div>

                <div className="company-name projects">
                  {project.description}
                </div>

                {/* Tech stack pills */}
                <div className="tech-pills">
                  {project.techStack.map((tech, langIndex) => (
                    <span key={langIndex} className="tech-pill">{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>

      <div className="spacer"></div>
    </>
  );
};

export default Projects;
